import { render, staticRenderFns } from "./DashboardData.vue?vue&type=template&id=037f43c6"
import script from "./DashboardData.vue?vue&type=script&lang=js"
export * from "./DashboardData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports